export default "__VITE_ASSET__CIWoMjPU__"